/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { GoToJoinHeading } from '../../../components/Headings/GoToJoinHeading';
import { NativeJoinButton } from '../../../components/Buttons/NativeJoinButton';
import { Spacing } from '../../../themes/GoToTheme';

const messages = defineMessages({
  heading: {
    id: 'goto.join.heading.desktopOnlyCaption',
  },
});

interface Props {
  onStartButtonClick: () => void;
}

export const GoToSecondJoinDesktopOnly: React.FC<Props> = ({
  onStartButtonClick,
}) => {
  const { formatMessage: f } = useIntl();
  return (
    <>
      <GoToJoinHeading greeting heading={f(messages.heading)} />
      <NativeJoinButton
        marginRight={Spacing.CoreLayout2}
        onStartButtonClick={onStartButtonClick}
      />
    </>
  );
};
